export default __webpack_public_path__ + "static/media/MA.37187db4.svg";